import React from 'react';
import './Header.css';
import {Link, NavLink} from "react-router-dom";
import Logo from "../Logo/Logo";
import {useTranslation} from "react-i18next";

function Header() {
    const { t } = useTranslation();
    return (
            <header>
                <div>
                    <Link to={'/'}><Logo/></Link>

                    <nav>
                        <ul>
                            <li><NavLink to={'/'}>{t('Home')}</NavLink></li>
                        </ul>
                    </nav>
                </div>
            </header>
    );
}

export default Header;